





import { Component, Vue } from "vue-property-decorator";
import AuthTab, { AuthTabItem } from "@/containers/AuthTab.vue";

@Component({
  components: {
    AuthTab
  }
})
export default class TabFrame extends Vue {
  tabItems: AuthTabItem[] = [
    {
      name: "groups-list",
      title: "グループリスト",
      scopes: ["company.default"]
    },
    {
      name: "groups-new",
      title: "新規登録",
      scopes: ["company.management"]
    },

  ];
}
